<template>
  <div class="app-container member-list">
    <basic-container>
      <avue-crud
        ref="crud"
        :option="organizationTagTableOption"
        :data="list"
        :page="page"
        :table-loading="listLoading"
        @current-change="handleCurrentChange"
        @refresh-change="handleRefreshChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">
        <template slot="menuLeft">
          <el-button
            v-if="permissions.organization_tag_add"
            lass="filter-item"
            size="small"
            type="primary"
            @click="addDialogVisible=true"
            icon="el-icon-plus">
            新增
          </el-button>
          <el-button
            v-if="permissions.organization_tag_import"
            lass="filter-item"
            size="small"
            type="primary"
            :loading="importLoading"
            @click="handleImport()"
            icon="el-icon-upload2">
            {{importName}}
          </el-button>
          <el-button
            v-if="permissions.organization_tag_import"
            class="filter-item"
            size="small"
            type="primary"
            :loading="importTemplateLoading"
            icon="el-icon-download"
            @click="handleImportTemplate()">
            {{importTemplateName}}
          </el-button>
        </template>

        <template slot="menu" slot-scope="scope">
          <el-button
            v-if="permissions.organization_tag_members_view"
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row, scope.index)">
            查看
          </el-button>
          <el-button
            v-if="permissions.organization_tag_edit"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, scope.index)">
            编辑
          </el-button>
          <el-button
            v-if="permissions.organization_tag_delete"
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, scope.index)">
            删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog class="upload-dialog"
      title="导入用户标签"
      :visible.sync="importMemberOrganizationTagVisible"
      width="30%">
      <template>
        <div>
          <el-label class="edit-dialog-item-label">请选择标签名称</el-label>
          <el-select v-model="importMemberOrganizationTagId" placeholder="请选择标签名称">
            <el-option
              v-for="item in importMemberOrganizationTags"
              :key="item.id"
              :label="item.tagName"
              :value="item.id"
            />
          </el-select>
          <el-upload
            ref="csvUploader"
            class="upload-dialog-input"
            action=""
            accept=".csv,.xls,.xlsx"
            :on-change="handleFileChange"
            :http-request="uploadCsvFile"
            :auto-upload="false">
            <el-button slot="trigger" size="medium" type="primary" plain>选取用户文件</el-button>
          </el-upload>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importMemberOrganizationTagVisible = false">取 消</el-button>
        <el-button :disabled="importLoading" type="primary" @click="handleImportSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增"
      :visible.sync="addDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="edit-dialog-item-label">标签名称</el-label>
          <el-input v-model="tagName" />
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="edit-dialog-item-label">标签名称</el-label>
          <el-input v-model="selectedTag.tagName"></el-input>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEditSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { importOrganizationTagList, fetchOrganizationTagImportTemplate  } from '@/api/admin/member';
  import {
    fetchOrganizationTagList,
    fetchAllOrganizationTagList,
    addOrganizationTag,
    editOrganizationTag,
    deleteOrganizationTag,
  } from '@/api/admin/tag';
  import { organizationTagTableOption } from '@/const/crud/admin/member';
  import { mapGetters } from 'vuex';

  const fileTypes = ['xls', 'xlsx', 'csv'];
  const isVaildFileType = (file) => {
    const { name, type } = file.raw;
    return name && fileTypes.includes(name.split('.').pop());
  };

  export default {
    name: 'organization-tag',
    data() {
      return {
        search: {
          current: 1,
          size: 10,
          sortField: 'id',
          sortPolicy: 'desc',
        },
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        importLoading: false,
        importName: '导入',
        importTemplateLoading: false,
        importTemplateName: '导入模板下载',
        list: [],
        organizationTagTableOption,
        listLoading: false,
        importMemberOrganizationTags: [],
        importMemberOrganizationTagId: '',
        importMemberOrganizationTagType: 'other',
        importMemberOrganizationTagFile: null,
        importMemberOrganizationTagVisible: false,
        addDialogVisible: false,
        tagName: '',
        editDialogVisible: false,
        selectedTag: {
          id: '',
          tagName: '',
          tagType: ''
        },
      };
    },
    async created() {
      this.initPage();
      this.getList();
    },
    activated() {
      this.initPage();
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      initPage() {
        this.page.currentPage = 1;
        this.page.pageSize = this.search.size;
        this.search.current = 1;
      },
      getList() {
        const {
          current,
          size,
          sortField,
          sortPolicy,
        } = this.search;
        const params = {
          current,
          size,
          sortField,
          sortPolicy,
        };

        this.listLoading = true;
        fetchOrganizationTagList(params)
          .then((response) => {
            const { records, total } = response.data.data;
            this.list = records;
            this.page.total = total;
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.listLoading = false;
          });
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.nickname = ''
        this.search.memberId = ''
        this.search.unionId = ''
        this.search.tagName = ''
        this.search.tagType = ''
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleRefreshChange() {
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getList()
      },
      handleSortChange(val) {
        if (val.prop == "insertedTime") {
          this.search.sortField = "id"
        } else {
          this.search.sortField = ""
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortField = "id"
          this.search.sortPolicy = "desc"
        }
        this.getList()
      },
      async handleImport() {
        const { data: { data: allTagList } } = await fetchAllOrganizationTagList();
        if (this.$refs.csvUploader) {
          this.$refs.csvUploader.clearFiles();
        }
        this.importMemberOrganizationTags = allTagList;
        this.importMemberOrganizationTagId = '';
        this.importMemberOrganizationTagVisible = true;
      },
      handleImportSubmit() {
        if (!this.importMemberOrganizationTagId) {
          this.$message.error('请选择标签名称');
          return false;
        }
        if (!this.importMemberOrganizationTagFile) {
          this.$message.error('请选择包含标签的csv/excel文件');
          return false;
        }
        if (this.importMemberOrganizationTagFile.size > 10 * 1024 * 1024) {
          this.$message.error('文件不可以大于 10M');
          return false;
        }

        this.$refs.csvUploader.submit();
      },
      handleFileChange(file, fileList) {
        if (!fileList || fileList.length === 0) {
          return false;
        }

        if (!isVaildFileType(file)) {
          this.$message.error('上传文件只能是csv或excel格式的文件!');
          if (fileList.length > 1) {
            // 当文件数大于1只保留之前的文件
            fileList.splice(1, 1);
          } else {
            // 否则清空控件的所有文件
            this.$refs.csvUploader.clearFiles();
          }
          return false;
        }

        // 当文件数大于 1 时替换之前的文件
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }

        this.importMemberOrganizationTagFile = fileList[0];
      },
      uploadCsvFile({ file }) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tagType', this.importMemberOrganizationTagType);
        formData.append('tagId', this.importMemberOrganizationTagId);

        this.importLoading = true;
        this.importName = '导入中...';
        importOrganizationTagList(formData)
          .then(() => {
            this.$message({
              showClose: true,
              message: '导入成功',
              type: 'success',
            });
            this.importMemberOrganizationTagVisible = false;
            this.initPage();
            this.getList();
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.importLoading = false;
            this.importName = '导入';
          });
      },
      handleImportTemplate() {
        this.importTemplateLoading = true;
        fetchOrganizationTagImportTemplate()
          .then((response) => {
            if (response && response.data) {
              window.location = response.data.data;
            }
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.importTemplateLoading = false;
          });
      },
      handleEdit(row, index) {
        this.selectedTag = Object.assign({}, row);
        this.editDialogVisible = true;
      },
      handleEditSubmit() {
        const { id, tagName } = this.selectedTag;
        if (!tagName) {
          this.$message.error('标签名称不可以为空');
          return;
        }

        editOrganizationTag(id, tagName)
          .then(() => {
            this.getList();
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success'
            });
            this.editDialogVisible = false;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      handleAddSubmit() {
        if (!this.tagName) {
          this.$message.error('标签名称不可以为空');
          return;
        }

        addOrganizationTag(this.tagName)
          .then(() => {
            this.getList();
            this.$message({
              showClose: true,
              message: '新增成功',
              type: 'success'
            });
            this.tagName = '';
            this.addDialogVisible = false;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      handleView(row, index) {
        this.$router.push({
          path: `/member/organization-tag/detail/${row.id}`
        });
      },
      handleDelete(row, index) {
        const { id, tagName } = row;
        this.$confirm(`是否确认删除【${tagName}】标签?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return deleteOrganizationTag(id);
        }).then(() => {
          this.getList();
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
        }).catch(() => {});
      },
    }
  };
</script>

<style lang="scss" scoped>
.member-list {
  &-filter {
    margin: 0 10px;

    /deep/ .el-input__inner {
      font-size: 14px;
      border: unset;
    }

    .el-row {
      width: 95%;
    }

    &-empty {
      display: block;
    }

    &-label {
      margin-right: 10px;
      color: #606266;
      font-size: 14px;
    }

    &-value {
      width: calc(100% - 12px) !important;
    }

    &-location-value {
      width: calc(100% - 12px) !important;

      input {
        border: unset !important;
      }
    }

    &-date {
      width: calc(100% - 180px) !important;
    }

    &-search {
      float: right;
      margin-right: 10px;
    }

    &-reset {
      float: right;
      margin-right: 10px;
      color: #5383f3;
      border-color: #5383f3;
    }
  }

  &-container {
    padding-top: 0;

    &-button {
      color: #409eff;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
    }
  }
}

.upload-dialog {
  .upload-dialog-input {
    margin: 5px 0;
  }
}

/deep/ .el-upload-list {
  height: 50px;
}

.edit-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}

</style>
